// src/components/layouts/Pages/PageHeader/CardHeaderWithCountry.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import { Form } from 'antd';
import CardHeader from './CardHeader';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
/**
 * CardHeaderWithCountry - Wrapper for CardHeader that watches countryCode
 * Uses Form.useWatch internally so only this component re-renders on country change
 * @param {object} props - All props to pass to CardHeader
 * @param {string} watchField - Form field to watch for country code. Default: 'countryCode'
 * @param {boolean} overlapsBackground - Whether card overlaps external background (PageHeader). Default: false
 */
const CardHeaderWithCountry = ({ watchField = 'countryCode', overlapsBackground = false, ...props }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // Get form context - may be undefined if not inside SimpleFormProvider
  const formContext = useSimpleFormContext();
  const form = formContext?.form;

  // PERFORMANCE: Form.useWatch is isolated in this component only
  // Only this wrapper component re-renders when country changes (not the entire CardHeader)
  // If form is not available (e.g., in PageHeader without SimpleFormProvider), countryCode will be undefined
  const countryCode = Form.useWatch(watchField, form);

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. RENDER
  // ─────────────────────────────────────────────────────────────────────────────
  return <CardHeader {...props} countryCode={countryCode} overlapsBackground={overlapsBackground} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderWithCountry;
